var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isModalVisible,
          expression: "isModalVisible"
        }
      ]
    },
    [
      _c("transition", { attrs: { name: "slide" } }, [
        _c(
          "div",
          {
            class: _vm.type == "" ? "modal-mask" : "modal-mask1",
            attrs: { id: "groupModal12" },
            on: { click: _vm.hide }
          },
          [
            _c(
              "div",
              {
                staticClass: "modal-dialog modal-dialog-slideout modal-lg",
                staticStyle: { "max-width": "100%" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  }
                }
              },
              [
                _c("div", { staticClass: "modal-content p-2" }, [
                  _c("div", { staticClass: "modal-header px-4 pt-2 pb-0" }, [
                    _c("div", { staticStyle: { width: "100%" } }, [
                      _c(
                        "a",
                        {
                          staticClass: "text-uppercase text-muted pt-1",
                          attrs: { href: "javascript:void(0);" },
                          on: { click: _vm.hide }
                        },
                        [
                          _c("img", {
                            staticClass: "back_icon mr-2",
                            attrs: {
                              src: require("@/assets/manager/back_button_icon.png")
                            }
                          }),
                          _vm._v("Back")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close float-right",
                          attrs: { type: "button" },
                          on: { click: _vm.hide }
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body" }, [
                    _c(
                      "div",
                      { staticClass: "modal-body- modal_add_rep d-none-" },
                      [
                        _c("div", { staticClass: "row mb-2 mt-3" }, [
                          _c("div", { staticClass: "col-6 pl-4" }, [
                            _c(
                              "div",
                              {
                                staticClass: "h3 d-inline mr-2 text-uppercase"
                              },
                              [_vm._v(_vm._s(_vm.menteeShortName))]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "text-uppercase btn btn-primary d-none mentee_title_btn"
                              },
                              [_vm._v("Apprentice")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 pr-4 text-right" }, [
                            _c("div", { staticClass: "text-muted" }, [
                              _vm._v("Mentor(s)")
                            ]),
                            _vm._v(" "),
                            _c(
                              "ul",
                              { staticClass: "list-inline mb-0" },
                              _vm._l(_vm.mentorsAssigned, function(
                                mentorAssigned,
                                index
                              ) {
                                return _c(
                                  "li",
                                  {
                                    key: index,
                                    staticClass:
                                      "list-inline-item font-weight-bold"
                                  },
                                  [_vm._v(_vm._s(mentorAssigned.name))]
                                )
                              }),
                              0
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mb-2 mt-0" }, [
                          _c("div", { staticClass: "col-6 pl-4" }, [
                            _c(
                              "div",
                              {
                                staticClass: "text-uppercase font-weight-bold"
                              },
                              [_vm._v("Add Rep")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 pr-4 text-right" })
                        ]),
                        _vm._v(" "),
                        _c("MenteeAddRepReview", {
                          ref: "MenteeAddReviewModal",
                          attrs: {
                            repTask: _vm.repTask,
                            menteeFirstName: _vm.menteeFirstName,
                            menteeShortName: _vm.menteeShortName,
                            menteeId: _vm.menteeId,
                            alignApproveDenyBtns: "type3",
                            action: "add_rep",
                            isSectionInAdd: _vm.isSection
                          },
                          on: {
                            closeMenteeAddRepModal: _vm.closeMenteeAddRepModal
                          }
                        }),
                        _vm._v(" "),
                        _c("MenteeRepHistory", {
                          ref: "MenteeRepHistoryModal",
                          attrs: {
                            menteeFirstName: _vm.menteeFirstName,
                            menteeShortName: _vm.menteeShortName,
                            menteeId: _vm.menteeId,
                            taskListId: _vm.taskListId,
                            subTaskId: _vm.subTaskId,
                            taskId: _vm.taskId,
                            isSection: _vm.isSection,
                            tasklistName: _vm.tasklistName,
                            taskName: _vm.taskName,
                            subTasks: _vm.subTasks
                          },
                          on: {
                            closeMenteeEditRepModal: _vm.closeMenteeEditRepModal
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" })
                ])
              ]
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bba1ff0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bba1ff0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manager/mentee_add_rep.vue
// module id = null
// module chunks = 